import { parseDeploymentStage } from '@easihub/esm';
import { ClientConfig } from '@easihub/models';

import { InjectionToken, type Type } from '@angular/core';

export const APP_ENV = new InjectionToken('APP_ENV', {
  factory: () => parseDeploymentStage(import.meta.env['VITE_APP_ENV'])
});

export const CLIENT_CONFIG = new InjectionToken<ClientConfig>('CLIENT_CONFIG');

export type Injected<T extends InjectionToken<unknown> | Type<unknown>> =
  T extends Type<infer I> ? I :
  T extends InjectionToken<infer I> ? I :
  never;
